import React from 'react'
import { getCookieValue } from '@core/Utils/cookies'
import { ExpandableToolboxSection } from './Common/ExpandableToolboxSection'

export const CookieInfo = () => {
  const webappVersion = React.useMemo(() => getCookieValue('webapp-version') ?? 'Not found', [])
  const allowExternalAccess = React.useMemo(
    () => getCookieValue('allow-external-access') ?? 'Not found',
    []
  )
  return (
    <ExpandableToolboxSection heading='Cookie Info'>
      <dl>
        <dt>Webapp Version:</dt>
        <dd>
          <span>{webappVersion}</span>
        </dd>
        <dt>Allow External Access</dt>
        <dd>
          <span>{allowExternalAccess}</span>
        </dd>
      </dl>
    </ExpandableToolboxSection>
  )
}
